import React from 'react';

import {isBenchlingTypeDefList, LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import SelectorOptionInput from 'metadata/SelectorOptionInput';

import {LeafTypeToValueEditorTSType, ValueInputProps} from './ValueInputTypes';

function valueToSchemaFieldSelectorOptionIds(
  value: LeafTypeToValueEditorTSType[LeafType.DROPDOWN_OPTION]
): Array<string> {
  if (value == null) {
    return [];
  }

  if (typeof value === 'string') {
    return [value];
  }

  return value;
}

export function DropdownValueInput(props: ValueInputProps<LeafType.DROPDOWN_OPTION>): JSX.Element {
  const value = props.valueInput.isValid ? valueToSchemaFieldSelectorOptionIds(props.valueInput.value) : [];

  function handleOnChange(schemaFieldSelectorOptionIds: Array<string>): void {
    if (isBenchlingTypeDefList(props.typeDef)) {
      props.onChange(schemaFieldSelectorOptionIds);
    } else {
      props.onChange(schemaFieldSelectorOptionIds[0] ?? null);
    }
  }

  return (
    <SelectorOptionInput
      {...props}
      defaultValue={{schemaFieldSelectorOptionIds: value}}
      schemaFieldSelectorId={props.schemaFieldSelectorId}
      shouldAllowMultiple={isBenchlingTypeDefList(props.typeDef)}
      onChange={({schemaFieldSelectorOptionIds}) => {
        handleOnChange(schemaFieldSelectorOptionIds);
      }}
      disabled={props.disabled}
    />
  );
}
